console.log("init Proteus treatments -- 1.01")

// atc links
observeSelector('[href*="#atc--"]', atc_link => {
  atc_link.addEventListener("click", async (e) => {

    let atc_href = e.currentTarget.getAttribute("href");
    const match = atc_href.match(/#atc--([\d\-]+)/);
    if (!match) return;

    const var_ids = match[1].split("-"); // ["12345678", "3456789"]

    // Build items array for cart/add.js
    const items = var_ids.map(id => ({
      id,
      quantity: 1
    }));

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      console.log("Added multiple items:", data);

      // optional: trigger cart refresh
      document.querySelector('a[href="/cart"][is="toggle-link"]').click();

    } catch (err) {
      console.error("ATC error", err);
    }
  });
})

// joe: 40216908529798
// bar: 40216907939974